<template>
  <div class="register-success">
    <img
      src="../../../assets/images/logos/measure-studio-logo-text.svg"
      class="content__paladin-logo register-success__logo"
    >
    <div>
      <div class="register-success__title">
        {{ $t('register.check_your_email_title') }}
      </div>
      <div class="register-success__email">
        {{ $t('register.check_your_email') }}
      </div>
      <div v-if="mcpOnboardingActive" class="register-success__mcp-next-step">
        {{ $t(registrationNextStepKey, { client: mcpClientName }) }}
      </div>
      <div
        class="register-success__support"
        v-html="$t('register.search_support_email')"
      />
    </div>

    <img
      v-if="displayLinkedinPixel"
      height="1"
      width="1"
      style="display: none;"
      alt=""
      src="https://px.ads.linkedin.com/collect/?pid=1646028&conversionId=1649052&fmt=gif"
    >

    <Footer />
  </div>
</template>

<script>
import Footer from '../../elements/layout/Footer.vue';
import { getMcpOnboarding } from '../../../utils/mcp_onboarding';
import { mcpClientReturnUrl } from '../../../utils/mcp_client';

export default {
  components: {
    Footer,
  },
  data() {
    const mcpOnboarding = getMcpOnboarding();

    return {
      mcpClient: mcpOnboarding?.client || 'generic',
      mcpOnboardingActive: !!mcpOnboarding,
    };
  },
  computed: {
    displayLinkedinPixel() {
      return process.env.RAILS_ENV === 'production';
    },
    mcpClientName() {
      return this.$t(`oauth.mcp.clients.${this.mcpClient}`);
    },
    registrationNextStepKey() {
      return mcpClientReturnUrl(this.mcpClient)
        ? 'oauth.mcp.registration_next_step_with_return'
        : 'oauth.mcp.registration_next_step_manual';
    },
  },
};
</script>

<style lang="scss" scoped>
  .register-success {
    @apply relative flex h-screen flex-col justify-between bg-neutral-300;

    &__logo {
      @apply mx-auto mt-[84px] mb-0 #{!important};
    }

    &__title {
      @apply mb-3 text-center text-4xl font-medium text-neutral-900;
    }

    &__email {
      @apply text-center text-md text-neutral-600;
    }

    &__mcp-next-step {
      @apply mx-auto mt-5 max-w-[520px] px-5 text-center text-md leading-6 text-neutral-700;
    }

    &__support {
      @apply mt-2 text-center text-md text-neutral-600;
    }

    .footer {
      @apply relative inset-x-0 w-auto;
    }
  }
</style>
